import { RouteConfig } from 'vue-router'
const Reserve = () => import(/* webpackChunkName: "reserve" */ '@reserve/Index.vue')
const ReserveMaster = () => import(/* webpackChunkName: "reserve" */ '@reserve/views/Master.vue')
const CalendarMaster = () => import(/* webpackChunkName: "reserve" */ '@reserve/views/CalendarMaster.vue')
const PopupMaster = () => import(/* webpackChunkName: "reserve" */ '@reserve/views/PopupMaster.vue')

const MonthView = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/MonthView/MonthView.vue')
const WeekView = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/WeekView/WeekView.vue')
const DayView = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/DayView/DayView.vue')
const SearchView = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/SearchView/SearchView.vue')

const ReserveResource = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/ReserveResource/ReserveResource.vue')
const ResourceInfo = () => import(/* webpackChunkName: "reserve" */ '@reserve/components/ResourceInfo/ResourceInfo.vue')

const routes: RouteConfig[] = [
    {
        path: '/reserve',
        component: Reserve,
        children: [
            {
                path: '',
                component: ReserveMaster,                        
                children: [
                    {
                        path: '',
                        component: CalendarMaster,
                        redirect: 'month',
                        children: [
                            {
                                path: 'month',
                                name: 'reserve-month',
                                component: MonthView
                            },
                            {
                                path: 'week',
                                name: 'reserve-week',
                                component: WeekView
                            },
                            {
                                path: 'day',
                                name: 'reserve-day',
                                component: DayView
                            },
                        ]
                    },
                    {
                        path: 'write',
                        name: 'reserve-write',
                        component: ReserveResource,
                        props: { isPopup: false }    
                    },
                    {
                        path: 'search',
                        name: 'reserve-search',
                        component: SearchView
                    }
                ],
            },
        ],
    },
    {
        path: 'reservePopup',
        component: PopupMaster,
        children: [
            {
                path: 'write',
                component: ReserveResource,
                props: { isPopup: true }            
            },
            {
                path: 'info',
                component: ResourceInfo,
                props: {isPopup: true}
            }
        ]
    }
]
export default routes
